module.exports = __webpack_public_path__ + "static/media/maxParties_50_75.0dcbedd9.png";